import { injectable } from "tsyringe";
import { BaseApi } from "../apiConfig/BaseApi";
import { ILocalityRepository } from "$src/domain/map/ILocalityRepository";
import { Locality } from "$src/domain/map/Locality";
import { ApiRoutes } from "../apiConfig/ApiRoutes";
import { Country } from "$src/domain/map/Country";
import { AddressValue } from "$src/domain/core/AddressValue";
import { Road } from "$src/domain/map/Road";
import { Geocode } from "$src/domain/map/GeoCode";
import { GeoLocation } from "$src/domain/projects/ProjectDetail";

@injectable()
export class LocalityRepositoryApi extends BaseApi implements ILocalityRepository {
  
    
    async getCountries(languageCode: string): Promise<Country[]> {
        try {

            const route = `${ApiRoutes.MAP.endpoint()}/countries`;

            const response = await this.apiClient.get<Country[]>(route, { languageCode: languageCode } );
            
            return response;
        } catch (error) {
            console.error('Error fetching countries by name:', error);
            throw error; 
        }
    }
    
    async getByName(countryCode: string, nameQuery: string): Promise<Locality[]> {
        try {

            const route = `${ApiRoutes.MAP.endpoint()}/${countryCode}/localities/name`;

            const response = await this.apiClient.get<Locality[]>(route, {nameQuery: nameQuery});
            
            return response;
        } catch (error) {
            console.error('Error fetching localities by name:', error);
            throw error; 
        }
    }

    async getByPostalCode(countryCode: string, postalCodeQuery: string): Promise<Locality[]> {
        try {

            const route = `${ApiRoutes.MAP.endpoint()}/${countryCode}/localities/postalcode`;

            const response = await this.apiClient.get<Locality[]>(route, {postalCodeQuery: postalCodeQuery});
            
            return response;
        } catch (error) {
            console.error('Error fetching localities by postal code:', error);
            throw error; 
        }
    }

    async geoCode(address: AddressValue): Promise<Geocode> {
        try {

            const route = `${ApiRoutes.MAP.endpoint()}/geocode`;

            const response = await this.apiClient.post<Geocode>(route, 
                address
            );
            
            return response;
        } catch (error) {
            console.error('Error geocoding address:', error);
            throw error; 
        }
    }

    async getRoadFromPoints(from: GeoLocation, to: GeoLocation): Promise<Road> {
        try {

            const route = `${ApiRoutes.MAP.endpoint()}/road-fromcodes`;

            const response = await this.apiClient.post<Road>(route, 
                {
                    from: from,
                    to: to
                }
            );
            
            return response;
        } catch (error) {
            console.error('Error fetching road from points:', error);
            throw error; 
        }
    }
   

    async getRoadFromPointtoAddress(from: GeoLocation, address: AddressValue): Promise<Road> {
        try {

            const route = `${ApiRoutes.MAP.endpoint()}/road`;

            const response = await this.apiClient.post<Road>(route, 
                {
                    from: from,
                    address: address
                }
            );
            
            return response;
        } catch (error) {
            console.error('Error fetching road from point to address:', error);
            throw error; 
        }
    }
}